var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-51.2, -51.2), scale(38.4)",
    fill: "#7ABA78",
    d: "M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "navigation"), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    fill: "#eeeeee",
    transform: "translate(42.666667, 42.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.333333,3.55271368e-14 C331.15408,3.55271368e-14 426.666667,95.5125867 426.666667,213.333333 C426.666667,331.15408 331.15408,426.666667 213.333333,426.666667 C95.5125867,426.666667 3.55271368e-14,331.15408 3.55271368e-14,213.333333 C3.55271368e-14,95.5125867 95.5125867,3.55271368e-14 213.333333,3.55271368e-14 Z M234.667936,43.9872251 L234.666667,85.3333333 L192,85.3333333 L191.998065,43.9873081 C114.800319,53.6146255 53.6146255,114.800319 43.9873081,191.998065 L85.3333333,192 L85.3333333,234.666667 L43.9872251,234.667936 C53.6142741,311.865996 114.800098,373.052014 191.998065,382.679359 L192,341.333333 L234.666667,341.333333 L234.667936,382.679442 C311.866218,373.052365 373.052365,311.866218 382.679442,234.667936 L341.333333,234.666667 L341.333333,192 L382.679483,191.999065 C373.052542,114.800626 311.866329,53.6143157 234.667936,43.9872251 Z M320,106.666667 L245.333333,245.333333 L106.666667,320 L181.333333,181.333333 L320,106.666667 Z M213.333333,192 C201.551259,192 192,201.551259 192,213.333333 C192,225.115408 201.551259,234.666667 213.333333,234.666667 C225.115408,234.666667 234.666667,225.115408 234.666667,213.333333 C234.666667,201.551259 225.115408,192 213.333333,192 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationSvgrepoCom);
export default __webpack_public_path__ + "static/media/navigation-svgrepo-com.621c090b8fe64ab746b1de31b55b90c4.svg";
export { ForwardRef as ReactComponent };